<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="600px">
      <v-card>
        <v-toolbar elevation="0">
          <v-toolbar-title class="pl-3 text--subtitle">
            <v-icon color="primary" style="padding-bottom: 2px">
              mdi-account-supervisor-outline
            </v-icon>
            <b class="pl-2" style="font-weight: 500"
              >{{ $t('message.pages.modalMaxUsers.limitReached') }}
            </b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="px-7 py-0">
          <v-row no-gutters>
            <v-col cols="12">
              <v-card-text class="pa-0" v-if="totalUsers">
                {{ $t('message.pages.modalMaxUsers.message1') }}
                <b>
                  {{ totalUsers }}
                  {{
                    totalUsers === 1
                      ? $t('message.pages.modalMaxUsers.message2sing')
                      : $t('message.pages.modalMaxUsers.message2')
                  }}
                  {{
                    addonUsers
                      ? addonUsers === 1
                        ? '(' +
                          addonUsers +
                          $t('message.pages.modalMaxUsers.message3sing')
                        : '(' +
                          addonUsers +
                          $t('message.pages.modalMaxUsers.message3')
                      : ''
                  }}
                </b>
                <br />
                {{
                  totalUsers + addonUsers === 1
                    ? $t('message.pages.modalMaxUsers.message4sing')
                    : $t('message.pages.modalMaxUsers.message4')
                }}
                <br />
                <!-- {{ $t('message.pages.modalMaxUsers.message6') }}
                <a
                  :href="helpLink"
                  target="_blank"
                  style="text-decoration: none"
                >
                  {{ $t('message.pages.modalMaxUsers.message7') }}
                </a> -->
              </v-card-text>
              <v-card-text class="pa-0" v-else>
                <p
                  v-html="$t('message.pages.modalMaxUsers.messageOldPlans')"
                ></p>
                <b>
                  {{
                    addonUsers
                      ? addonUsers === 1
                        ? $t('message.pages.modalMaxUsers.messageOldPlans2') +
                          addonUsers +
                          $t('message.pages.modalMaxUsers.messageOldPlans3sing')
                        : $t('message.pages.modalMaxUsers.messageOldPlans2') +
                          addonUsers +
                          $t('message.pages.modalMaxUsers.messageOldPlans3')
                      : ''
                  }}
                </b>
                <br />
                <br />
                {{ $t('message.pages.modalMaxUsers.message6') }}
                <a @click="helpLink" style="text-decoration: none">
                  {{ $t('message.pages.modalMaxUsers.message7') }}
                </a>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-8 py-6 mt-4">
          <v-spacer></v-spacer>
          <v-btn class="mr-2 px-4" text @click="handleClose">
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn color="primary" @click="handleCart">
            {{ $t('message.pages.modalMaxUsers.buyMoreSlotButton') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import linkHelper from '@/utils/linkHelper.mixin.js'

export default {
  name: 'WarningMaxUsers',
  mixins: [linkHelper],
  components: {},
  data: () => ({
    open: false,
    totalUsers: null,
    addonUsers: null,
  }),
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
    }),
    helpLink() {
      return this.getHelpLink()
    },
  },
  mounted() {
    this.$root.$on('modalMaxUsers', () => {
      this.open = true

      const addonUsers = this.userPlanInfo.addons?.slot_user
        ? this.userPlanInfo.addons?.slot_user[0]?.quantity
        : 0

      const planUsers =
        Number(this.userPlanInfo.subscription?.metadata?.users) ?? 0
      const amountOfUsers = addonUsers + planUsers
      this.addonUsers = addonUsers
      this.totalUsers = amountOfUsers
    })
  },
  beforeDestroy() {
    this.$root.$off('modalMaxUsers')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_ONLY_CUSTOMIZING']),
    handleClose() {
      this.open = false
    },
    handleCart() {
      this.handleClose()
      this.UPDATE_ONLY_CUSTOMIZING(true)
      this.$router.push({ name: 'Cart' })
    },
    handleEvent(event) {
      const e = event
      if (e.key) {
        e.key === 'Escape' && this.handleClose()
      }
      return
    },
    handleTalkToUs() {},
    handleChat() {
      this.$crisp.push(['do', 'chat:show'])
      this.$crisp.push(['do', 'chat:open'])
    },
  },
}
</script>

<style scoped>
.notice-img {
  height: 270px;
  margin: 48px 0px;
}

@media only screen and (max-height: 680px) {
  .notice-img {
    height: 200px !important;
    margin: 12px 0px;
  }
}

@media only screen and (max-height: 535px) {
  .notice-img {
    margin: 0px;
  }
}
</style>
